import styled from "styled-components";
import { COLORS, responsive, THEME } from "./constants.style";
import { MuiTypography } from "../components";

export const AmountBadgeText = styled(MuiTypography)(() => ({
  padding: "4px 10px",
  marginLeft: "8px",
  backgroundColor: COLORS.cirrus_black2,
  borderRadius: "4px",
}));

export const LabelWithIconText = styled(MuiTypography)`
  color: ${COLORS.primary_light_blue};
  display: flex;
  align-items: center;
  font-size: ${THEME.fontSizes[500]} !important;
  font-weight: ${THEME.fontWeights.bold} !important;
  font-family: ${THEME.fontFamilies.primary} !important;
  border-radius: 8px !important;

  svg {
    margin-right: 8px;
    color: ${COLORS.primary_light_blue};
  }
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${COLORS.cirrus_black3};
`;

export const SeparatorDotted = styled.div`
  border-bottom: 1px dotted ${COLORS.primary_light_blue3};
`;

export const AccordionHeaderRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 16px 16px;
  gap: 32px;

  ${responsive.MOBILE`
    padding: 8px 0px 8px 0px;
    gap: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    &.with-custom-mobile-padding {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      gap: 16px;
      padding: 0px 16px 8px 0px;
    }
  `};

  .MuiButton-root {
    height: auto;
    padding-left: 4px;
    margin-top: 4px;
    svg {
      margin-right: 10px;
    }
  }
`;
